export class GptSearchEnvironment {
  public static getName = () => 'gpt-search';
  public static getEnvironment = (env: Record<string, string>) => ({
    benzingaURL: new URL(env.url ?? 'https://www.benzinga.com'),
    url: new URL(env.url ?? 'https://api.benzinga.com/'),
  });
}
